<Label value={label}>
  <input
    class='input is-primary'
    type="text"
    placeholder="เติมคำในช่องว่าง"
    bind:value={$value}
    required={false}
  >
</Label>

<script lang='ts'>
  import type { Writable } from "svelte/store";
  import { writable } from "svelte/store";
  import Label from "./Label.svelte";

  export let label: string | null = null;
  export let value: Writable<string> = writable('');
</script>
